import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import { useForm } from "@inertiajs/react"
import { usePage } from "@inertiajs/react"
import { FormField } from "@/components/core/form_field"
import { Link } from "@inertiajs/react"
import { Head } from "@inertiajs/react"

export default function ForgotPassword({ className, errors, ...props }) {
  const { data, setData, post, transform, processing } = useForm({
    email: '',
  })

  const { flash } = usePage().props

  const handleSubmit = (event) => {
    event.preventDefault()
    transform(data => ({ user: data }))
    post('/password')
  }

  return (
    <>
      <Head>
        <title>founder/mode | Forgot Password</title>
      </Head>
      <div className="flex min-h-svh flex-col items-center justify-center gap-6 bg-background p-6 md:p-10">
        <div className="w-full max-w-sm">
          <div className={cn("flex flex-col gap-6 p-6 rounded-lg shadow", className)} {...props}>
            <form onSubmit={handleSubmit}>
              <div className="flex flex-col gap-6">
                <div className="flex flex-col items-center gap-2">
                  <Link
                    href="#"
                    className="flex flex-col items-center gap-2 font-medium"
                  >
                    <span className="sr-only">founder/mode</span>
                  </Link>
                  <h1 className="text-xl font-bold">Forgot your password?</h1>
                  <p className="text-center text-sm text-muted-foreground">
                    Enter your email and we&apos;ll send you a link to reset your password.
                  </p>
                </div>
                <div className="flex flex-col gap-6">
                  <div className="flex flex-col gap-3">
                    <FormField
                      label="Email"
                      name="email"
                      type="email"
                      placeholder="m@example.com"
                      value={data.email}
                      onChange={(e) => setData('email', e.target.value)}
                      errors={errors}
                    />

                    {flash.alert && (
                      <p className="text-[0.8rem] mt-1 font-medium text-destructive">{flash.alert}</p>
                    )}
                  </div>
                  <Button type="submit" className="w-full" disabled={processing}>
                    Send Reset Link
                  </Button>
                </div>
              </div>
            </form>
            <div className="text-center text-sm">
              Remember your password?{" "}
              <Link href="/login" className="underline underline-offset-4">
                Login
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
